import { apiGET } from './api';

export const getCreateQuickSightEmbedUrl = (dashboardName = '', siteId = null) => {
  let url = '/aws/create-quicksight-embed-url';

  if (dashboardName) {
    url += `?dashboard_name=${dashboardName}`;
  }

  if (siteId) {
    url += `&site_id=${siteId}`;
  }

  return apiGET(url);
};
